import React from 'react';

import { connect } from 'react-redux';

class RemoveFavoriteIcon extends React.Component {
  render() {
    return (
      <svg>
        <g transform="matrix(0.20639835,0,0,0.20639835,5.3999998,5.400103)"><path
       d="m 209.521,13.251 c -23.354,0 -45.25,9.378 -61.264,25.251 C 132.244,22.629 110.347,13.251 86.993,13.251 39.025,13.251 0,52.276 0,100.244 c 0,38.814 14.157,73.228 44.554,108.3 18.824,21.72 61.053,52.391 84.548,68.739 5.729,3.986 12.44,5.979 19.154,5.979 6.714,0 13.429,-1.994 19.159,-5.98 23.496,-16.351 65.725,-47.021 84.545,-68.738 30.396,-35.071 44.554,-69.484 44.554,-108.3 0,-47.968 -39.026,-86.993 -86.993,-86.993 z m -62.885,211.434 c -40.825,0 -73.92,-33.095 -73.92,-73.921 0,-40.825 33.095,-73.92 73.92,-73.92 40.825,0 73.92,33.095 73.92,73.92 0,40.825 -33.095,73.921 -73.92,73.921 z"
       id="path5"
       fill={this.props.color || "#DE171F"}
        /><path
       d="m 102.098,130.765 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 l 89.076,0 c 11.046,0 20,-8.954 20,-20 0,-11.046 -8.954,-20 -20,-20 l -89.076,0 z"
       id="path7"
       fill={this.props.color || "#DE171F"}
     /></g>
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(RemoveFavoriteIcon);



// WEBPACK FOOTER //
// ./src/icons/remove-favorite.js